import { render, staticRenderFns } from "./ExportPdfInvoice.vue?vue&type=template&id=3724906e&scoped=true"
import script from "./ExportPdfInvoice.vue?vue&type=script&lang=ts"
export * from "./ExportPdfInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724906e",
  null
  
)

export default component.exports